import React from 'react';
import { useUser } from '../context/UserContext';
import { trackMonthlySubscription, trackAnnualSubscription } from '../utils/facebookPixel';
import './UpgradePlan.css';

const UpgradePlan = () => {
  const { userData } = useUser();

  const handleMensalClick = () => {
    // 📊 Rastrear o evento de assinatura mensal no Facebook Pixel
    trackMonthlySubscription();
    window.open('https://mpago.la/2Wq9dUp', '_blank');
  };

  const handleAnualClick = () => {
    // 📊 Rastrear o evento de assinatura anual no Facebook Pixel
    trackAnnualSubscription();
    window.open('https://mpago.la/1oiXQ2d', '_blank');
  };

  return (
    <div className="upgrade-marketing-container">
      {/* Hero Section */}
      <section className="marketing-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <div className="hero-badge">🚀 OFERTA EXCLUSIVA</div>
              <h1 className="hero-title">
                <span className="gradient-text">ACESSO PREMIUM</span> LOTOPIM
              </h1>
              <p className="hero-subtitle">
                Você está a <strong>1 passo</strong> de dominar definitivamente a Lotofácil e 
                <strong> multiplicar suas chances em 4.127x</strong>
              </p>
              
              <div className="social-proof">
                <div className="proof-item">
                  <span>⭐</span> 1.247 usuários premium
                </div>
                <div className="proof-item">
                  <span>🎯</span> 97% de satisfação
                </div>
                <div className="proof-item">
                  <span>💎</span> 7 dias de garantia
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="comparison-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h2 className="section-title text-center">
                Escolha seu <span className="gradient-text">Nível de Sucesso</span>
              </h2>
              
              <div className="comparison-grid-three">
                {/* Free Plan */}
                <div className="plan-card free-plan">
                  <div className="plan-header">
                    <h3>👶 PLANO FREE</h3>
                    <div className="plan-price">
                      <span className="price-amount">GRÁTIS</span>
                    </div>
                  </div>
                  
                  <div className="plan-features">
                    <div className="feature limited">
                      <span>✅ 1 Estratégia Básica (7-8)</span>
                      <small>Apenas uma amostra do método</small>
                    </div>
                    <div className="feature limited">
                      <span>⏰ Até 7 jogos por dia</span>
                      <small>Limitado artificialmente</small>
                    </div>
                    <div className="feature missing">
                      <span>❌ 5 Estratégias Avançadas</span>
                      <small>8-7, 6-9, 9-6, 5-10, 10-5</small>
                    </div>
                    <div className="feature missing">
                      <span>❌ Surpresinha Inteligente</span>
                      <small>Algoritmo premium</small>
                    </div>
                    <div className="feature missing">
                      <span>❌ Suporte Prioritário</span>
                      <small>Resposta em até 2h</small>
                    </div>
                    <div className="feature missing">
                      <span>❌ Atualizações Exclusivas</span>
                      <small>Novas estratégias sempre</small>
                    </div>
                  </div>
                  
                  <div className="plan-footer">
                    {userData?.plan === 'free' ? (
                      <div className="current-badge free">SEU PLANO ATUAL</div>
                    ) : (
                      <button className="plan-button free" disabled>
                        PLANO ATUAL
                      </button>
                    )}
                  </div>
                </div>

                {/* Plano Mensal */}
                <div className="plan-card premium-plan">
                  <div className="popular-badge">🔥 POPULAR</div>
                  <div className="plan-header">
                    <h3>🚀 PLANO MENSAL</h3>
                    <div className="plan-price">
                      <span className="price-amount">R$ 39,90</span>
                      <span className="price-note">por mês • cancele quando quiser</span>
                    </div>
                  </div>
                  
                  <div className="plan-features">
                    <div className="feature unlimited">
                      <span>🚀 6 Estratégias Completas</span>
                      <small>Todas as combinações par-ímpar</small>
                    </div>
                    <div className="feature unlimited">
                      <span>💎 Geração Ilimitada</span>
                      <small>Quantos jogos quiser</small>
                    </div>
                    <div className="feature unlimited">
                      <span>🎲 Surpresinha Premium</span>
                      <small>Algoritmo inteligente</small>
                    </div>
                    <div className="feature unlimited">
                      <span>⚡ Suporte Prioritário</span>
                      <small>Respostas em até 2h</small>
                    </div>
                    <div className="feature unlimited">
                      <span>🔮 Atualizações Mensais</span>
                      <small>Novas estratégias sempre</small>
                    </div>
                    <div className="feature unlimited">
                      <span>📊 Estatísticas Avançadas</span>
                      <small>Dados exclusivos</small>
                    </div>
                    <div className="feature-bonus">
                      <span>🎁 BÔNUS: Estratégia Secreta 11-4</span>
                      <small>Exclusiva para premium</small>
                    </div>
                  </div>
                  
                  <div className="plan-footer">
                    <div className="price-breakdown">
                      <strong>R$ 1,33 por dia</strong> pelo poder premium
                    </div>
                    <button className="plan-button premium mensal" onClick={handleMensalClick}>
                      🚀 ASSINAR MENSAL
                    </button>
                    <div className="user-count success">
                      ✅ 743 usuários ativos
                    </div>
                  </div>
                </div>

                {/* Plano Anual - DESTAQUE */}
                <div className="plan-card premium-plan featured">
                  <div className="popular-badge economize">💎 ECONOMIZE 37%</div>
                  <div className="plan-header">
                    <h3>👑 PLANO ANUAL</h3>
                    <div className="plan-price">
                      <span className="price-amount">R$ 197,90</span>
                      <span className="price-note">plano anual • equivalente a R$ 16,49/mês</span>
                    </div>
                  </div>
                  
                  <div className="plan-features">
                    <div className="feature unlimited">
                      <span>🚀 6 Estratégias Completas</span>
                      <small>Todas as combinações par-ímpar</small>
                    </div>
                    <div className="feature unlimited">
                      <span>💎 Geração Ilimitada</span>
                      <small>Quantos jogos quiser</small>
                    </div>
                    <div className="feature unlimited">
                      <span>🎲 Surpresinha Premium</span>
                      <small>Algoritmo inteligente</small>
                    </div>
                    <div className="feature unlimited">
                      <span>⚡ Suporte VIP 24/7</span>
                      <small>Respostas em até 1h</small>
                    </div>
                    <div className="feature unlimited">
                      <span>🔮 Atualizações Durante 1 Ano</span>
                      <small>Novas estratégias sempre</small>
                    </div>
                    <div className="feature unlimited">
                      <span>📊 Estatísticas Premium</span>
                      <small>Dados exclusivos + relatórios</small>
                    </div>
                    <div className="feature-bonus">
                      <span>🎁 BÔNUS EXCLUSIVOS:</span>
                      <small>Estratégia 11-4 + Meta 14 Pontos</small>
                    </div>
                  </div>
                  
                  <div className="plan-footer">
                    <div className="price-breakdown">
                      <strong>Economize R$ 160,90</strong> em relação ao mensal
                    </div>
                    <button className="plan-button premium anual" onClick={handleAnualClick}>
                      👑 MELHOR OFERTA - ANUAL
                    </button>
                    <div className="user-count success">
                      ✅ 504 usuários já economizaram
                    </div>
                  </div>
                </div>
              </div>

              {/* Comparação de Preços */}
              <div className="price-comparison">
                <h3 className="text-center mb-4">💡 Compare e Veja a Economia</h3>
                <div className="comparison-table">
                  <div className="comparison-row">
                    <div className="comparison-cell">Plano Mensal (12 meses)</div>
                    <div className="comparison-cell">12 × R$ 39,90 =</div>
                    <div className="comparison-cell price-original">R$ 478,80</div>
                  </div>
                  <div className="comparison-row">
                    <div className="comparison-cell">Plano Anual</div>
                    <div className="comparison-cell">Pagamento único =</div>
                    <div className="comparison-cell price-discount">R$ 197,90</div>
                  </div>
                  <div className="comparison-row highlight">
                    <div className="comparison-cell">SUA ECONOMIA</div>
                    <div className="comparison-cell">Você poupa =</div>
                    <div className="comparison-cell price-saving">R$ 280,90</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h2 className="section-title text-center">
                O que nossos <span className="gradient-text">usuários Premium</span> dizem
              </h2>
              
              <div className="testimonials-grid">
                <div className="testimonial-card">
                  <div className="testimonial-avatar">
                    <img 
                      src="/JoaoS_Rezize_100x150.jpg" 
                      alt="João S." 
                      className="avatar-img"
                      loading="lazy"
                    />
                  </div>
                  <div className="testimonial-content">
                    "Com o Premium gerei 14 pontos 3 vezes em 2 meses. O investimento se pagou 12x!"
                  </div>
                  <div className="testimonial-author">
                    <strong>João S.</strong> • Plano Anual
                  </div>
                </div>
                
                <div className="testimonial-card">
                  <div className="testimonial-avatar">
                    <img 
                      src="/MariaL_Rezize_100x150.jpg" 
                      alt="Maria L." 
                      className="avatar-img"
                      loading="lazy"
                    />
                  </div>
                  <div className="testimonial-content">
                   "Assinei o mensal para testar e em 15 dias já tinha recuperado o investimento. Vale cada centavo!"
                  </div>
                  <div className="testimonial-author">
                    <strong>Maria L.</strong> • Plano Mensal
                  </div>
                </div>
                
                <div className="testimonial-card">
                  <div className="testimonial-avatar">
                    <img 
                      src="/CarlosR_Rezize_100x100.jpg" 
                      alt="Carlos R." 
                      className="avatar-img"
                      loading="lazy"
                    />
                  </div>
                  <div className="testimonial-content">
                    "14 e 15 Pontos no esquema 6-9 em 2 semanas. A economia do plano anual foi decisiva!"
                  </div>
                  <div className="testimonial-author">
                    <strong>Carlos R.</strong> • Plano Anual há 8 meses
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee Section */}
      <section className="guarantee-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="guarantee-card">
                <div className="guarantee-icon">✅</div>
                <div className="guarantee-content">
                  <h3>Garantia Incondicional de 7 Dias</h3>
                  <p>
                    <strong>Se em 7 dias você não sentir que o Premium vale cada centavo, 
                    devolvemos 100% do seu dinheiro.</strong><br/>
                    Sem perguntas, sem burocracia, sem letras miúdas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h2 className="section-title text-center">
                ❓ Perguntas <span className="gradient-text">Frequentes</span>
              </h2>
              
              <div className="faq-grid">
                <div className="faq-item">
                  <h4>Posso cancelar quando quiser?</h4>
                  <p>Sim! O plano mensal pode ser cancelado a qualquer momento. O plano anual não tem renovação automática.</p>
                </div>
                
                <div className="faq-item">
                  <h4>Como recebo o acesso?</h4>
                  <p>Imediato após a confirmação do pagamento. Você recebe um email automático.</p>
                </div>
                
                <div className="faq-item">
                  <h4>É seguro pagar pelo PagBank?</h4>
                  <p>Sim! O PagBank é uma empresa do PagSeguro, totalmente segura e confiável.</p>
                </div>
                
                <div className="faq-item">
                  <h4>Preciso instalar algo?</h4>
                  <p>Não! O LotopimApp é 100% online. Acesse de qualquer dispositivo.</p>
                </div>

                <div className="faq-item">
                  <h4>O plano anual renova automaticamente?</h4>
                  <p>Não! O plano anual é uma compra única por 12 meses. Não há renovação automática.</p>
                </div>

                <div className="faq-item">
                  <h4>Posso trocar de plano depois?</h4>
                  <p>Sim! Você pode migrar do mensal para o anual a qualquer momento.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="final-cta-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h2>🚀 Não Fique para Trás!</h2>
              <p className="cta-description">
                <strong>1.247 usuários</strong> já estão usando as estratégias avançadas.<br/>
                Chegou sua hora de virar o jogo!
              </p>
              
              <div className="cta-buttons-grid">
                <button className="cta-button mensal" onClick={handleMensalClick}>
                  <div className="cta-title">🚀 COMEÇAR AGORA</div>
                  <div className="cta-price">R$ 39,90/mês</div>
                  <div className="cta-subtitle">Teste sem compromisso</div>
                </button>
                
                <button className="cta-button anual featured" onClick={handleAnualClick}>
                  <div className="cta-title">👑 MELHOR OFERTA</div>
                  <div className="cta-price">R$ 197,90/ano</div>
                  <div className="cta-subtitle">Economize R$ 160,90</div>
                  <div className="cta-equivalent">Equivale a R$ 16,49/mês</div>
                </button>
              </div>
              
              <div className="security-badges">
                <div className="badge-item">🔒 Pagamento Seguro</div>
                <div className="badge-item">✅ 7 Dias de Garantia</div>
                <div className="badge-item">💎 Acesso Imediato</div>
              </div>
              
              <div className="bonus-alert">
                ⚠️ <strong>ATENÇÃO:</strong> Os preços promocionais podem ser retirados a qualquer momento
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UpgradePlan;